import cn from 'classnames';
import { useContext } from 'react';

import DefaultLink from 'components/common/DefaultLink';
import Facebook from 'components/icons/communication/Facebook';
import Twitter from 'components/icons/communication/Twitter';
import { BrandContext, HOME_CHEF } from 'context/BrandContext';
import { brandData } from 'helpers/BrandData';
import useBrand from 'hooks/useBrand';

const SocialMediaIconLinks = () => {
  const { brand } = useContext(BrandContext);
  const isHomeChef = useBrand(HOME_CHEF);

  const buttonClasses = [
    'inline-flex',
    'items-center',
    'justify-center',
    'p-2',
    'mr-3',
    'rounded-full',
    'transition-all',
    'hover:text-white-100',
    'focus:text-white-100',
    'text-white-100',
  ];

  if (!brand) return null;

  return (
    <div className="mt-5">
      <DefaultLink
        className={cn(buttonClasses, 'bg-blue-facebook')}
        to={brandData(brand).facebookUrl}
        isExternal={true}
        target="_blank"
        rel="noopener noreferrer"
        variation="Primary"
      >
        <Facebook />
        <span className="sr-only">View {brand}'s Facebook page</span>
      </DefaultLink>
      {isHomeChef && (
        <DefaultLink
          className={cn(buttonClasses, 'bg-blue-twitter')}
          to="https://twitter.com/realhomechef"
          isExternal={true}
          target="_blank"
          rel="noopener noreferrer"
          variation="Primary"
        >
          <Twitter />
          <span className="sr-only">View {brand}'s Twitter page</span>
        </DefaultLink>
      )}
    </div>
  );
};

export default SocialMediaIconLinks;
